import { isAbsoluteURL, isRelativeURL } from '../guards';
import languages from './languages';

const getUrlLangAttribute = (url: string) => {
  if (!(isAbsoluteURL(url) || isRelativeURL(url))) return undefined;

  const { pathname } = isRelativeURL(url) ? new URL(url, 'https://lucid.url') : new URL(url);

  const currentLinkLanguage = languages.find(
    language => pathname.startsWith(`${language.url_lang_prefix}/`) || pathname === language.url_lang_prefix,
  );

  return currentLinkLanguage?.short_code ?? 'en';
};

export default getUrlLangAttribute;
